// extracted by mini-css-extract-plugin
export default {"container":"Dk-z","bubbleNav":"Ek-z","graphic":"Fk-z","contact":"Gk-z"};